// extracted by mini-css-extract-plugin
module.exports = {"modalDescription":"styles_modalDescription__12qlE","description":"styles_description__aDwXg","image":"styles_image__31ZUE"};